import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { CheckCircle2 } from 'lucide-react';

const pricingLines = [
    'White Glove 3-Phase VA Program: $900/month in Year 1, $699/month in Year 2, $299/month in Year 3 and beyond',
    'Additional VA: $699/month for their first 12 months, then $299/month',
    'Timeclock Monitoring for VAs you already have: $100/month per VA',
];

export function PricingClarity() {
    return (
        <section className="bg-white py-16 md:py-20" data-testid="pricing-clarity">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-8">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">Pricing Clarity</h2>
                </motion.div>
                <motion.ul {...fadeUp} className="space-y-4">
                    {pricingLines.map((line) => (
                        <li key={line} className="flex items-start gap-3">
                            <CheckCircle2 size={18} className="text-gold-400 flex-shrink-0 mt-1" strokeWidth={1.5} />
                            <p className="text-navy-900 text-base font-semibold leading-relaxed">{line}</p>
                        </li>
                    ))}
                </motion.ul>
            </div>
        </section>
    );
}
